import { useMemo } from 'react';
import { LOCALIZATIONS_ARRAY, DEFAULT_LOCALE, LOCALIZATIONS } from '@/utils/type/localizations';
import { usePathname } from 'next/navigation';

export function useCurrentLocale(): LOCALIZATIONS {
  const pathname = usePathname();

  const locale = useMemo(() => {
    const firstSegment = pathname?.split('/')?.[1];
    const currentLocale = LOCALIZATIONS_ARRAY.includes(
      (firstSegment ?? '') as (typeof LOCALIZATIONS_ARRAY)[number],
    )
      ? (firstSegment as (typeof LOCALIZATIONS_ARRAY)[number])
      : DEFAULT_LOCALE;

    return currentLocale;
  }, [pathname]);

  return locale;
}
